import React from "react";
import { Helmet } from "react-helmet";
import { Container, Row, Col, Button } from "react-bootstrap";
import Fade from "react-reveal/Fade";
import { IoRemoveOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import { 
  FaShieldAlt, 
  FaClock, 
  FaDollarSign, 
  FaUserCheck, 
  FaSlidersH, 
  FaMapMarkedAlt, 
  FaPhoneAlt 
} from "react-icons/fa";
import Header from '../components/Header';
import Footer from '../components/FooterMain';
import service from "../images/aboutBanner.jpg";
import delivery from "../images/aboutMain.png";

const About = () => {
  return (
    <div id="about-us-page" style={{ overflowX: "hidden" }}>
      <Helmet>
        <meta
          name="description"
          content="Learn more about Go Move Canada, one of Canada's most trusted moving companies offering local, long-distance, and corporate relocation services."
        />
        <title>About Us | Go Move Canada</title>
      </Helmet>
      
      <Header />

      {/* -------------------------- DESKTOP FONT OVERRIDES --------------------------- */}
      <style>{`
        .bgAboutImage {
          min-height: 170px !important;
        }
        @media (min-width: 768px) {
          .bgAboutImage {
            min-height: 300px !important;
          }
          /* Matched Component Typography Framework with Reduced Heading Sizes */
          .about-heading {
            font-family: 'Archivo', sans-serif !important;
            font-weight: bold !important;
          }
          .about-subheading {
            font-family: 'Lato', sans-serif !important;
            font-size: 16px !important;
            font-weight: 600 !important;
          }
          .about-body-text {
            font-family: 'Lato', sans-serif !important;
            font-size: 15px !important;
          }
          .about-grid-title {
            font-family: 'Lato', sans-serif !important;
            font-size: 20px !important;
            font-weight: 700 !important;
          }
          .about-feature-title {
            font-family: 'Lato', sans-serif !important;
            font-size: 16px !important;
            font-weight: 700 !important;
          }
        }
      `}</style>

      {/* -------------------------- START HERO BANNER --------------------------- */}
      <div 
        className="bgAboutImage"
        style={{
          backgroundImage: `url(${service})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "flex-end",
          position: "relative"
        }}
      >
        {/* Dark Overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            // backgroundColor: "rgba(0, 0, 0, 0.35)",
            zIndex: 1
          }}
        />

        <Container style={{ position: "relative", zIndex: 2, paddingBottom: "25px" }} className="px-3 px-md-5">
          <Fade left>
            <div className="d-flex flex-column align-items-center align-items-md-start text-center text-md-start">
              <h1
                className="aboutTitle about-heading"
                style={{
                  color: "#ffffff",
                  fontFamily: "Lato, sans-serif",
                  fontSize: "clamp(1.8rem, 3.5vw, 2.8rem)",
                  fontWeight: "700",
                  marginBottom: "5px"
                }}
              >
                ABOUT US
              </h1>
              
              {/* Breadcrumb Navigation */}
              <div
                className="aboutSubTitle"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <Link to="/" style={{ textDecoration: "none" }}>
                  <h6
                    className="about-body-text"
                    style={{
                      color: "#ffac93",
                      marginRight: "10px",
                      marginBottom: 0,
                      cursor: "pointer",
                      fontFamily: "Lato, sans-serif",
                      fontWeight: "500"
                    }}
                  >
                    Home
                  </h6>
                </Link>
                <h6 className="about-body-text" style={{ color: "#ffffff", fontFamily: "Lato, sans-serif", marginBottom: 0 }}>
                  / About us
                </h6>
              </div>
            </div>
          </Fade>
        </Container>
      </div>
      {/* -------------------------- END HERO BANNER --------------------------- */}

      {/* -------------------------- START COMPANY INTRODUCTION --------------------------- */}
      <Container className="py-4 py-md-5 my-2 my-md-3 px-3 px-md-5"> 
        <Row className="align-items-center">
          <Col xs={12} md={6} className="order-1">
            <Fade left>
              <span className="about-subheading" style={{ color: "#D84214", fontFamily: "Lato, sans-serif", fontWeight: "600", letterSpacing: "0.5px" }}>
                WHO WE ARE <IoRemoveOutline size={30} style={{ marginBottom: "5px" }} />
              </span>
              <h2 className="about-heading" style={{ fontFamily: "Lato, sans-serif", fontWeight: "700", marginBottom: "15px", marginTop: "10px", color: "#243136", fontSize: "clamp(1.5rem, 2.5vw, 2rem)" }}>
                Go Move Canada – Canada's Trusted Moving Company
              </h2>
              <p className="about-body-text" style={{ lineHeight: "1.7", fontFamily: "Lato, sans-serif", color: "#555", fontSize: "15px" }}>
                Go Move Canada is one of Canada's most trusted moving companies, delivering seamless, efficient, and secure relocation services to individuals, families, and businesses nationwide. Whether you're planning a local move across the city or a long-distance relocation to a new province, our team of trained moving professionals ensures every step of your journey is handled with care, precision, and reliability.
              </p>
              <p className="about-body-text" style={{ lineHeight: "1.7", fontFamily: "Lato, sans-serif", color: "#555", fontSize: "15px" }}>
                With deep roots in the Canadian moving industry, we combine hands-on expertise with a genuine customer-first approach — because we know that moving isn't just about transporting boxes. It's about protecting what matters most to you.
              </p>
            </Fade>
          </Col>
          
          <Col xs={12} md={6} className="text-center mt-4 mt-md-0 order-2 d-none d-md-block">
            <Fade right>
              <img
                src={delivery}
                alt="Go Move Canada Team"
                style={{ width: "100%", height: "auto", borderRadius: "12px", boxShadow: "0px 10px 25px rgba(0,0,0,0.06)" }}
              />
            </Fade>
          </Col>
        </Row>
      </Container>
      {/* -------------------------- END COMPANY INTRODUCTION --------------------------- */}

      {/* -------------------------- START SERVICES GRID --------------------------- */}
      <div style={{ 
        background: "linear-gradient(180deg, #fdfefe 0%, #f4f7f9 100%)", 
        borderTop: "1px solid #e2e8f0", 
        borderBottom: "1px solid #e2e8f0" 
      }}>
        <Container className="px-3 px-md-5 mercantile-grid-container py-5">
          <div className="text-center mb-5">
            <Fade bottom>
              <span className="about-subheading" style={{ color: "#D84214", fontFamily: "Lato, sans-serif", fontWeight: "600", letterSpacing: "1px" }}>OUR SOLUTIONS</span>
              <h2 className="about-heading" style={{ fontFamily: "Lato, sans-serif", fontWeight: "700", marginTop: "10px", color: "#243136", fontSize: "clamp(1.5rem, 2.5vw, 2rem)" }}>Our Moving Services Across Canada</h2>
              <p className="about-body-text" style={{ fontFamily: "Lato, sans-serif", color: "#666", maxWidth: "600px", margin: "10px auto 0", fontSize: "15px" }}>We offer comprehensive, end-to-end moving solutions designed to meet every relocation need</p>
            </Fade>
          </div>
          
          <Row>
            {[
              { title: "Residential Moving Services", desc: "Safe and efficient home moves across Canada." },
              { title: "Corporate & Office Relocation", desc: "Minimal downtime, maximum efficiency for businesses." },
              { title: "Long-Distance & Intercity Moving", desc: "Reliable moves between cities and provinces." },
              { title: "Professional Packing & Unpacking", desc: "Expert handling and protective packaging for all your belongings." },
              { title: "Furniture Protection, Handling & Transport", desc: "Specialized care for heavy, fragile, and valuable items." },
              { title: "Secure Storage & Logistics Coordination", desc: "Flexible storage solutions to support your move timeline." }
            ].map((service, index) => (
              <Col md={4} sm={6} xs={12} className="mb-4" key={index}>
                <Fade bottom delay={index * 100}>
                  <div style={{
                    backgroundColor: "#ffffff",
                    padding: "35px 25px 30px 25px",
                    borderRadius: "12px",
                    position: "relative",
                    overflow: "hidden",
                    height: "100%",
                    boxShadow: "0 10px 25px -5px rgba(36, 49, 54, 0.04), 0 8px 10px -6px rgba(36, 49, 54, 0.04)",
                    border: "1px solid #eaedf1",
                    transition: "transform 0.3s ease"
                  }}>
                    <div style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "4px",
                      backgroundColor: "#D84214"
                    }} />
                    
                    <h5 className="about-subheading about-grid-title" style={{ 
                      fontFamily: "Lato, sans-serif", 
                      fontWeight: "700", 
                      color: "#243136", 
                      marginBottom: "12px", 
                      fontSize: "19px",
                      lineHeight: "1.4"
                    }}>
                      {service.title}
                    </h5>
                    
                    <p className="about-body-text" style={{ 
                      fontFamily: "Lato, sans-serif", 
                      color: "#555", 
                      fontSize: "14.5px", 
                      marginBottom: "0", 
                      lineHeight: "1.6" 
                    }}>
                      {service.desc}
                    </p>
                  </div>
                </Fade>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
      {/* -------------------------- END SERVICES GRID --------------------------- */}

      {/* -------------------------- START WHY CHOOSE US --------------------------- */}
      <Container className="py-5 my-2 my-md-3 px-3 px-md-5">
        <Row className="align-items-center">
          <Col lg={4} md={12} className="mb-5 lg-mb-0">
            <Fade left>
              <span className="about-subheading" style={{ color: "#D84214", fontFamily: "Lato, sans-serif", fontWeight: "600", letterSpacing: "0.5px" }}>
                OUR MOVING STANDARDS <IoRemoveOutline size={30} style={{ marginBottom: "5px" }} />
              </span>
              <h2 className="about-heading" style={{ fontFamily: "Lato, sans-serif", fontWeight: "700", marginBottom: "15px", marginTop: "10px", color: "#243136", fontSize: "clamp(1.5rem, 2.5vw, 2rem)" }}>
                Why Choose Go Move Canada?
              </h2>
              <p className="about-body-text" style={{ lineHeight: "1.7", fontFamily: "Lato, sans-serif", color: "#555", marginBottom: "0", fontSize: "15px" }}>
                With hundreds of moving companies in Canada to choose from, here's what sets us apart. We prioritize clear communication and full accountability throughout the process, so you're never left in the dark — from booking to final delivery.
              </p>
            </Fade>
          </Col>
          
          <Col lg={8} md={12}>
            <Row>
              {[
                { icon: <FaUserCheck size={20} />, title: "Experienced, Trained Moving Professionals", desc: "Our crew is skilled, background-checked, and committed to careful handling." },
                { icon: <FaDollarSign size={20} />, title: "Transparent Pricing & Clear Estimates", desc: "No hidden fees. You know what you're paying before we arrive." },
                { icon: <FaClock size={20} />, title: "Reliable Scheduling & On-Time Delivery", desc: "We respect your time and stick to agreed timelines." },
                { icon: <FaShieldAlt size={20} />, title: "High Standards of Safety & Care", desc: "Industry-grade equipment and careful packing practices protect your belongings." },
                { icon: <FaSlidersH size={20} />, title: "Customized Moving Plans", desc: "Every move is unique. We tailor our services to your specific needs and budget." }
              ].map((item, idx) => (
                <Col sm={6} xs={12} className="mb-4" key={idx}>
                  <Fade bottom delay={idx * 100}>
                    <div style={{ display: "flex", alignItems: "start" }}>
                      <div style={{
                        backgroundColor: "rgba(216, 66, 20, 0.08)",
                        color: "#D84214",
                        padding: "12px",
                        borderRadius: "8px",
                        marginRight: "15px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0
                      }}>
                        {item.icon}
                      </div>
                      <div>
                        <h5 className="about-subheading about-feature-title" style={{ fontFamily: "Lato, sans-serif", fontWeight: "700", fontSize: "15px", marginBottom: "6px", color: "#243136" }}>{item.title}</h5>
                        <p className="about-body-text" style={{ fontFamily: "Lato, sans-serif", color: "#666", fontSize: "14px", lineHeight: "1.6", marginBottom: "0" }}>{item.desc}</p>
                      </div>
                    </div>
                  </Fade>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
      {/* -------------------------- END WHY CHOOSE US --------------------------- */}

      {/* -------------------------- START COMMITMENT TO QUALITY --------------------------- */}
      <div style={{ backgroundColor: "#ffffff", padding: "60px 0", color: "#333", borderTop: "1px solid #f0f0f0" }}>
        <Container className="px-3 px-md-5">
          <Row className="align-items-center">
            <Col md={6}>
              <Fade left>
                <span className="about-subheading" style={{ color: "#D84214", fontFamily: "Lato, sans-serif", fontWeight: "600", letterSpacing: "0.5px" }}>
                  OUR CORE MISSION <IoRemoveOutline size={30} style={{ marginBottom: "5px" }} />
                </span>
                <h2 className="about-heading" style={{ fontFamily: "Lato, sans-serif", fontWeight: "700", color: "#243136", marginBottom: "20px", marginTop: "10px", fontSize: "clamp(1.5rem, 2.5vw, 2rem)" }}>
                  Our Commitment to Quality & Trust
                </h2>
                <p className="about-body-text" style={{ fontFamily: "Lato, sans-serif", lineHeight: "1.7", color: "#555", fontSize: "15px" }}>
                  At Go Move Canada, trust is the foundation of everything we do. We hold ourselves to the highest standards of professionalism, operational transparency, and customer care — because your belongings, your time, and your peace of mind matter.
                </p>
                <p className="about-body-text" style={{ fontFamily: "Lato, sans-serif", lineHeight: "1.7", color: "#555", marginBottom: "0", fontSize: "15px" }}>
                  From your initial consultation to the final item delivered, our mission is to minimize stress, protect your valuables, and provide a smooth, dependable moving experience. Our growing base of satisfied clients across Canada is a testament to our dedication to consistency, integrity, and service excellence.
                </p>
              </Fade>
            </Col>
            
            <Col md={6} className="mt-5 mt-md-0">
              <Fade right>
                <div style={{
                  border: "1px solid #eef2f5",
                  borderRadius: "15px",
                  padding: "40px",
                  backgroundColor: "#f8f9fa",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.01)"
                }}>
                  <FaMapMarkedAlt size={32} style={{ color: "#D84214", marginBottom: "20px" }} />
                  <h4 className="about-subheading" style={{ fontFamily: "Lato, sans-serif", fontWeight: "700", color: "#243136", marginBottom: "15px", fontSize: "18px" }}>
                    Proudly Serving Customers Across Canada
                  </h4>
                  <p className="about-body-text" style={{ fontFamily: "Lato, sans-serif", lineHeight: "1.7", color: "#666", fontSize: "14.5px", marginBottom: "0" }}>
                    Go Move Canada serves major cities and regions from coast to coast, offering flexible and scalable moving solutions for both local and long-distance relocations. No move is too big or too small — we bring the same level of professionalism and care to every job.
                  </p>
                </div>
              </Fade>
            </Col>
          </Row>
        </Container>
      </div>
      {/* -------------------------- END COMMITMENT TO QUALITY --------------------------- */}

      {/* -------------------------- START FINAL CTA BANNER --------------------------- */}
      <div
        className="Commitment-Banner"
        style={{
          backgroundColor: "#f8f9fa",
          padding: "70px 0",
          color: "#243136",
          textAlign: "center",
          borderTop: "1px solid #f0f0f0"
        }}
      >
        <Container className="px-3 px-md-5">
          <Row className="justify-content-center">
            <Col md={9} lg={8}>
              <Fade bottom>
                <h2 className="about-heading" style={{ fontFamily: "Lato, sans-serif", fontWeight: "700", marginBottom: "15px", color: "#243136", fontSize: "clamp(1.5rem, 2.5vw, 2rem)" }}>
                  Looking for a reliable moving company in Canada?
                </h2>
                <p className="about-body-text" style={{ fontFamily: "Lato, sans-serif", lineHeight: "1.7", color: "#666", fontSize: "15px", marginBottom: "30px" }}>
                  Whether you're moving your home, office, or anything in between, Go Move Canada delivers a streamlined experience built on trust, expertise, and reliability.
                </p>
                
                <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center gap-3">
                  <a href="/" style={{ textDecoration: "none" }}>
                    <Button
                      className="about-body-text"
                      style={{
                        backgroundColor: "#D84214",
                        borderColor: "#D84214",
                        color: "#fff",
                        fontWeight: "600",
                        padding: "12px 30px",
                        borderRadius: "6px",
                        display: "flex",
                        alignItems: "center",
                        boxShadow: "0 5px 15px rgba(216, 66, 20, 0.15)",
                        fontFamily: "Lato, sans-serif",
                        fontSize: "14px"
                      }}
                    >
                      <FaPhoneAlt className="me-2" size={12} /> Ready to Move? Get a Free Quote Today.
                    </Button>
                  </a>
                </div>
              </Fade>
            </Col>
          </Row>
        </Container>
      </div>
      {/* -------------------------- END FINAL CTA BANNER --------------------------- */}
      <Footer />
    </div>
  );
};

export default About;